<div class="modal-header">
  <h5 class="modal-title-adapted" id="form-modal-title">Feedback geben</h5>
  <button (click)="this.activeModal.dismiss()" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body p-4" data-bs-backdrop="false">
  @if (stage === 0) {
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="row row-gap-3">
        <div class="row">Wie zufrieden sind Sie mit Phishlab?</div>
        <div class="row">
          <div class="col text-center">
            <div class="d-flex">
              <button
                type="button"
                class="btn btn-outline-primary flex-fill me-2 fs-1 py-4"
                (click)="selectMood('happy')"
                [class.btn-primary]="form.get('mood')?.value === 'happy'">
                😊
              </button>

              <button
                type="button"
                class="btn btn-outline-primary flex-fill me-2 fs-1 py-4"
                (click)="selectMood('neutral')"
                [class.btn-primary]="form.get('mood')?.value === 'neutral'">
                😐
              </button>

              <button
                type="button"
                class="btn btn-outline-primary flex-fill fs-1 py-4"
                (click)="selectMood('sad')"
                [class.btn-primary]="form.get('mood')?.value === 'sad'">
                😞
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <label for="feedback-textarea" class="form-label">Hier können Sie zusätzlich Feedback abgegeben:</label>
        </div>
        <div class="row">
          <div class="col text-center">
            <textarea id="feedback-textarea" class="form-control" rows="3" formControlName="feedback"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            @if (showSuppressOption) {
              <div class="form-check mt-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="feedback-dont-show-again"
                  (change)="dontShowAgain = $any($event.target).checked" />
                <label class="form-check-label text-muted" for="feedback-dont-show-again">
                  Nach dem Erstellen einer Kampagne nicht mehr anzeigen
                </label>
              </div>
            }
            <button type="submit" class="btn btn-primary">Senden</button>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <div class="row row-gap-3">
      <div class="row">
        Nehmen Sie gerne an dieser Umfrage teil, damit wir Phishlab für Sie noch weiter verbessern können (Dauer: ca. 3
        Minuten):
      </div>
      <div class="row">
        <div class="col text-center">
          <a href="https://viadee.limequery.com/627854?lang=de-informal" target="_blank">LimeSurvey Umfrage</a>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button type="button" class="btn btn-primary" (click)="this.activeModal.close()">Schließen</button>
        </div>
      </div>
    </div>
  }
</div>
